import { render, staticRenderFns } from "./UploadField.vue?vue&type=template&id=53372fde&scoped=true"
import script from "./UploadField.vue?vue&type=script&lang=js"
export * from "./UploadField.vue?vue&type=script&lang=js"
import style0 from "./UploadField.vue?vue&type=style&index=0&id=53372fde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53372fde",
  null
  
)

export default component.exports